module.exports = __webpack_public_path__ + "img/chinesecompany74.009d0e13.png";